import { useParams } from "react-router-dom";
import GoBack from "../core/components/goBack";
import { useAccounts } from "../core/lib/mockAccounts";
import Navbar from "../core/components/NavBar";
import { useContext, useEffect, useState } from "react";
import UserContext from "../core/UserContext";
import { FaUserCircle } from "react-icons/fa";
import { PpaPolicyCard, PpaSummaryCard, ViewPolicy } from "./accountComponents";
import { useNavigate } from "react-router-dom";
import DefaultModal from "../core/components/modals";
import apiRoutes from "../api/apiRoutes";

function ViewAccount() {
  const { userData } = useContext(UserContext);
  const params = useParams();
  const mount = useNavigate();

  const [viewPolicy, setViewPolicy] = useState(null);

  useEffect(() => {
    mount(`?view-policy=${viewPolicy}`);
  }, [viewPolicy, mount]);

  const [openModal, setOpenModal] = useState({
    id: null,
    partialWithdrawal: false,
    surrenderPolicy: false,
    withdrawalRequest: false,
  });

  const handleToggleModal = (id, name, state) => {
    setOpenModal((prev) => ({
      ...prev,
      id,
      [name]: state,
      ...(state &&
        Object.keys(prev).reduce((acc, key) => {
          if (key !== name && key !== "id") acc[key] = false;
          return acc;
        }, {})),
    }));
  };

  const [withdrawalAmount, setWithdrawalAmount] = useState("");

  const { getAccount } = useAccounts({
    endpoint: apiRoutes.ppaSummary,
    param: params.id,
  });

  const { currentItems } = useAccounts({
    endpoint: apiRoutes.allAccounts,
    worker: userData.data.id,
  });

  const selectedPolicy = currentItems.filter(
    (fils) => fils.id === Number(params.id)
  );

  const foundQuotation =
    selectedPolicy[0]?.quotations?.find(
      (quote) => quote.temporaryId === viewPolicy
    ) ||
    selectedPolicy[0]?.jointQuotations?.find(
      (quote) => quote.temporaryId === viewPolicy
    );

  const { allPpaSummary } = useAccounts({
    endpoint: apiRoutes.allPpaSummary,
    param: params.id,
  });

  const selectedUser = getAccount;
  const selectedProfile = allPpaSummary[0];

  if (!selectedUser) {
    return <div>User Not Found!</div>;
  }

  const ppaSummary = [
    {
      id: 0,
      icon: "/ppa_wallet.svg",
      title: "Current PPA Balance",
      amount: selectedUser.currentPpaBalance,
    },
    {
      id: 1,
      icon: "/ppa_growth.svg",
      title: "Investment Premiums Paid",
      amount: selectedUser?.investmentPremiumsPaid,
    },
    {
      id: 2,
      icon: "/ppa_paymethod.svg",
      title: "Management Charges",
      amount: selectedUser?.managementCharges,
    },
    {
      id: 3,
      icon: "/ppa_cash.svg",
      title: "Total Withdrawals",
      amount: selectedUser?.totalWithdrawals,
    },
    {
      id: 4,
      icon: "/ppa_invest.svg",
      title: "Declared Investment Return",
      amount: selectedUser?.declaredInvestmentReturn,
    },
  ];

  return (
    <>
      <main className="tw-font-haas tw-space-y-8">
        <Navbar
          name={
            userData
              ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
              : ""
          }
        />
        <GoBack back={"/accounts"} />

        <section className="tw-min-w-full tw-px-6">
          <div className="tw-space-y-6">
            <div className="tw-flex tw-items-center tw-gap-x-2">
              <FaUserCircle className="tw-w-8 tw-h-8" />
              <div className="tw-font-semibold tw-text-xl">
                {selectedPolicy[0]?.name
                  ? selectedPolicy[0]?.name
                  : selectedProfile?.user?.name ?? "N/A"}
              </div>
            </div>
            <div>
              <div className="tw-font-semibold tw-text-xl">
                Personal Private Account (PPA) Summary
              </div>
              <p>Review your PPA details before making a payment.</p>
            </div>
          </div>

          <div className="tw-hidden tw-flex tw-flex-end tw-justify-end">
            <p>All Policies</p>
            <p>Active Policies</p>
          </div>

          <section className="tw-flex tw-grow-0 tw-flex-wrap tw-items-start tw-gap-2">
            {ppaSummary?.map((summary) => (
              <PpaSummaryCard
                key={summary.id}
                src={summary.icon}
                alt={summary.title}
                title={summary.title}
                amount={summary.amount}
              />
            ))}
          </section>

          <hr className="tw-py-4" />

          <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 tw-items-center tw-justify-between">
            <div className="tw-font-semibold tw-text-xl">My Policies</div>
            <div className="tw-flex tw-items-center tw-gap-x-2">
              <button
                onClick={() =>
                  handleToggleModal(null, "partialWithdrawal", true)
                }
                className="tw-text-sm tw-font-semibold tw-text-[#BEC663] tw-w-fit tw-h-10 tw-bg-transparent tw-border tw-border-[#BEC663] tw-rounded-lg tw-p-2 tw-px-2"
              >
                Request Partial Withdrawal
              </button>
              <button
                onClick={() => handleToggleModal(null, "surrenderPolicy", true)}
                className="tw-text-sm tw-font-semibold tw-text-[#BEC663] tw-w-fit tw-h-10 tw-bg-transparent tw-border tw-border-[#BEC663] tw-rounded-lg tw-p-2 tw-px-2"
              >
                Surrender Policy
              </button>
            </div>
          </div>

          <section className="tw-py-8 tw-flex tw-flex-wrap tw-grow-0 tw-items-center tw-gap-2">
            {selectedPolicy[0]
              ? [
                  ...(selectedPolicy[0]?.quotations || []),
                  ...(selectedPolicy[0]?.jointQuotations || []),
                ]?.map((quotation, index) => (
                  <PpaPolicyCard
                    key={quotation.id || index}
                    headline={
                      quotation.savingsType === "regular"
                        ? "Regular Premium"
                        : "Single Premium"
                    }
                    polNumTitle="Active"
                    polNum={
                      quotation.permanentId
                        ? quotation.permanentId
                        : quotation.temporaryId ?? "N/A"
                    }
                    totalPremTitle="Total Premium to be paid"
                    totalPrem={`MUR ${
                      quotation.premiumAmount
                        ? parseFloat(quotation.premiumAmount).toLocaleString()
                        : 0
                    }`}
                    ppaAmountTitle="PPA Amount"
                    ppaAmount={`MUR ${
                      quotation.fundValue
                        ? parseFloat(quotation.fundValue).toLocaleString()
                        : 0
                    }`}
                    polStatusTitle="Policy Status"
                    polStatus={quotation.status || "N/A"}
                    polDateTitle="Next Due Date"
                    polDate={
                      quotation.nextDueDate
                        ? new Date(quotation.nextDueDate).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )
                        : "Not available"
                    }
                    view={() => setViewPolicy(quotation.temporaryId)}
                  />
                ))
              : allPpaSummary.map((ppa) => (
                  <PpaPolicyCard
                    key={ppa.id}
                    headline={
                      ppa.savingsType
                        ? ppa.savingsType + " Premium"
                        : "Not Available"
                    }
                    polNumTitle="Active"
                    polNum={
                      ppa.permanentId
                        ? ppa.permanentId
                        : ppa.temporaryId ?? "N/A"
                    }
                    totalPremTitle="Total Premium to be paid"
                    totalPrem={`MUR ${
                      ppa.premiumAmount
                        ? parseFloat(ppa.premiumAmount).toLocaleString()
                        : 0
                    }`}
                    ppaAmountTitle="PPA Amount"
                    ppaAmount={`MUR ${
                      ppa.fundValue
                        ? parseFloat(ppa.fundValue).toLocaleString()
                        : 0
                    }`}
                    polStatusTitle="Policy Status"
                    polStatus={ppa.status || "N/A"}
                    polDateTitle="Next Due Date"
                    polDate={
                      ppa.nextDueDate
                        ? new Date(ppa.nextDueDate).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )
                        : "Not available"
                    }
                    view={() => setViewPolicy(ppa.temporaryId)}
                  />
                ))}
          </section>
        </section>
      </main>
      {viewPolicy &&
        (() => {
          const ppaData = allPpaSummary?.find(
            (ppa) => ppa?.temporaryId === viewPolicy
          );

          const policyData = ppaData || foundQuotation;

          const osttable = ppaData?.Osttables?.[0]?.code;

          return policyData ? (
            <ViewPolicy
              key={policyData.temporaryId || "N/A"}
              polNumTitle="Policy Number"
              polNum={
                policyData.permanentId
                  ? policyData.permanentId
                  : policyData.temporaryId ?? "N/A"
              }
              polTypeTitle="Policy Type"
              polType={policyData.savingsType || "N/A"}
              polStatusTitle="Status"
              polStatus={policyData.status || "N/A"}
              polStartTitle="Start Date"
              polStart={
                policyData.intendedCommencementDate
                  ? new Date(
                      policyData.intendedCommencementDate
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "Not Available"
              }
              polMatureTitle="Maturity Date"
              polMature={
                policyData.intendedCommencementDate
                  ? new Date(
                      new Date(policyData.intendedCommencementDate).setFullYear(
                        new Date(
                          policyData.intendedCommencementDate
                        ).getFullYear() + policyData.termNumber
                      )
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "Not Available"
              }
              polPremTitle="Premium Amount"
              polPrem={`MUR ${policyData.premiumAmount || 0}`}
              polFreqTitle="Payment Frequency"
              polFreq={policyData.paymentInsurancePlan || 0}
              polOrderTitle="Standing Order"
              polOrder={osttable || "Not specified"}
              polHolderTitle="Policyholder"
              polHolder={
                selectedPolicy[0]?.name
                  ? selectedPolicy[0]?.name
                  : selectedProfile?.user?.name ?? "N/A"
              }
              polInsurerTitle="Insurer"
              polInsurer="ILA"
              polBenTitle="Beneficiary"
              polBen="Not specified"
              policyStatus="Policy Status"
              application={policyData}
              close={() => setViewPolicy(null)}
            />
          ) : null;
        })()}

      {openModal.partialWithdrawal && (
        <DefaultModal
          close={() => handleToggleModal(null, "partialWithdrawal", false)}
          headline="Request Partial Withdrawal"
          content="You are about to withdraw a portion of your Personal Private Account (PPA). The maximum withdrawal allowed is MUR 525"
          label="Withdrawal Amount"
          placeholder="Enter Amount"
          leftbtn="Canel"
          leftbtnfunc={() =>
            handleToggleModal(null, "partialWithdrawal", false)
          }
          rightbtn="Continue Withdrawal"
          rightbtnfunc={
            withdrawalAmount !== ""
              ? () => handleToggleModal(null, "withdrawalRequest", true)
              : undefined
          }
          inputValue={withdrawalAmount}
          onChangeValue={(e) => setWithdrawalAmount(e.target.value)}
          inputError={withdrawalAmount === "" ? "Please enter an amount" : ""}
          disabled={withdrawalAmount === "" ? true : false}
          rightbtnClass={
            withdrawalAmount === "" ? "tw-cursor-not-allowed tw-opacity-50" : ""
          }
          iconClass="tw-hidden"
          addedContent={
            <div className="tw-bg-[#F9F9F9] tw-rounded-lg tw-flex tw-flex-col tw-items-center tw-jusitify-center tw-w-full tw-h-auto tw-border tw-border-black/20 tw-p-3 tw-text-sm">
              <ol className="tw-list-decimal tw-flex tw-flex-col tw-items-start">
                <li className="tw-pl-2 tw-py-1">
                  You can request a withdrawal after the first 10 years.{" "}
                </li>
                <li className="tw-pl-2 tw-py-1">
                  Subsequent withdrawals can be made every 5 years.
                </li>
                <li className="tw-pl-2 tw-py-1">
                  {" "}
                  Processing time: 5 business days.
                </li>
                <li className="tw-pl-2 tw-py-1">
                  Ensure your account meets the minimum balance requirement.
                </li>
              </ol>
            </div>
          }
        />
      )}

      {openModal.surrenderPolicy && (
        <DefaultModal
          close={() => handleToggleModal(null, "surrenderPolicy", false)}
          headline="Surrender Policy"
          content="By surrendering your policy, you will receive a payout of MUR 2,500. However, this action will permanently terminate your policy, and you will no longer be eligible for any future benefits."
          leftbtn="Keep My Policy"
          leftbtnfunc={() => handleToggleModal(null, "surrenderPolicy", false)}
          rightbtn="Confirm & Surrender"
          icon="/warning.svg"
          onSubmit={() => {}}
          labelClass="tw-hidden"
          inputClass="tw-hidden"
        />
      )}

      {openModal.withdrawalRequest && (
        <DefaultModal
          close={() => handleToggleModal(null, "withdrawalRequest", false)}
          headline="Withdrawal Request Submitted"
          content="Your request to withdraw MUR 525 from your Personal Private Account (PPA) has been successfully submitted. Please allow up to 5 business days for processing. You will receive an update via email once the transaction is complete."
          icon="/checked.svg"
          leftbtn="Close"
          leftbtnfunc={() =>
            handleToggleModal(null, "withdrawalRequest", false)
          }
          rightbtn="View Transaction History"
          labelClass="tw-hidden"
          inputClass="tw-hidden"
        />
      )}
    </>
  );
}

export default ViewAccount;
